(() => {
  const onInteraction = (event) => {
    const target = event.target.closest('[data-dbd-event]');
    if (!target) return;
    const detail = {
      event: target.dataset.dbdEvent,
      product: target.dataset.dbdProduct || null,
      path: location.pathname
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'dbd_interaction', ...detail });
    document.dispatchEvent(new CustomEvent('dbd:interaction', { detail }));
  };
  document.addEventListener('click', onInteraction);
})();
